/* ==========================================================================
   Jane Lushka — cart drawer enhancements (loaded globally, defer)

   1) Keeps the cart-drawer HEADER count "(N)" in sync. The theme's cart.js only
      re-renders the line items, the footer (.js-cart-footer-contents) and the
      cart-icon-bubble on an in-drawer quantity change — NOT the drawer header —
      so the "(N)" went stale. We recompute it from the live quantity inputs
      whenever the drawer subtree changes (qty change / remove / add re-render).

   2) Shop the Look (LimeSpot CrossSell bundle) adds to cart via LimeSpot's own
      JS, which never touches the theme — so the drawer never opened. We watch
      for a bundle add-to-cart, wait for the cart to actually change, then
      refresh the drawer contents and open it (the same renderContents()/open()
      the theme uses for its own product form).
   ========================================================================== */
(function () {
  'use strict';

  var jsonHeaders = { 'X-Requested-With': 'XMLHttpRequest' };

  function getDrawer() {
    return document.querySelector('cart-drawer');
  }

  /* ---- 1) header "(N)" sync -------------------------------------------- */
  function syncDrawerCount() {
    var drawerEl = document.querySelector('[data-cart-drawer]');
    if (!drawerEl) return;
    var countEl = drawerEl.querySelector('[data-cart-drawer-count]');
    if (!countEl) return;
    var inputs = drawerEl.querySelectorAll('.cart-drawer-items [name="updates[]"]');
    var n = 0;
    inputs.forEach(function (input) { n += parseInt(input.value, 10) || 0; });
    var next = n > 0 ? ' (' + n + ')' : '';
    // Only write when it actually changed — avoids a MutationObserver feedback loop.
    if (countEl.textContent !== next) countEl.textContent = next;
  }

  var drawerForObserve = document.querySelector('[data-cart-drawer]');
  if (drawerForObserve && 'MutationObserver' in window) {
    // Observe the stable [data-cart-drawer] node: it survives both partial
    // (cart.js) and full (renderContents) re-renders of its children.
    new MutationObserver(syncDrawerCount).observe(drawerForObserve, {
      childList: true,
      subtree: true
    });
  }

  /* ---- 2) Shop the Look (LimeSpot bundle) → open the drawer ------------- */
  function refreshAndOpenDrawer() {
    var drawer = getDrawer();
    if (!drawer || typeof drawer.renderContents !== 'function') return;
    fetch('/?sections=cart-drawer,cart-icon-bubble', { headers: jsonHeaders })
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        drawer.renderContents({ sections: sections });
        if (typeof drawer.open === 'function') drawer.open();
        syncDrawerCount();
      })
      .catch(function () { /* fail quietly — item is still in the cart */ });
  }

  document.addEventListener(
    'click',
    function (event) {
      var target = event.target;
      if (!target || !target.closest) return;
      var btn = target.closest(
        'limespot-box[data-box-style="bundle"] .ls-bundle-add-to-cart'
      );
      if (!btn) return;

      // LimeSpot adds asynchronously and gives us no reliable event, so poll the
      // cart until item_count changes (capped at ~6s), then open the drawer.
      fetch('/cart.js', { headers: jsonHeaders })
        .then(function (r) { return r.json(); })
        .then(function (before) {
          var tries = 0;
          var timer = setInterval(function () {
            tries += 1;
            fetch('/cart.js', { headers: jsonHeaders })
              .then(function (r) { return r.json(); })
              .then(function (now) {
                if (now.item_count !== before.item_count) {
                  clearInterval(timer);
                  refreshAndOpenDrawer();
                } else if (tries >= 24) {
                  clearInterval(timer);
                }
              })
              .catch(function () { clearInterval(timer); });
          }, 250);
        })
        .catch(function () { /* no-op */ });
    },
    true
  );
})();
